import InnerVacancy from '@/routes_new/inner/vacancy/InnerVacancy';
import basic from '@/routes_new/inner/vacancy/basic';
import landing from '@/routes_new/inner/vacancy/landing';
import tests from '@/routes_new/inner/vacancy/tests';
import VacancyTestSettings from '@/routes_new/inner/vacancy/test/VacancyTestSettings';
import VcvExternalIntegration from './integration/VcvExternalIntegration';
import VcvVacancyHeadhunter from './integrations/VcvVacancyHeadhunter';
import VcvVacancyHackerrank from './integrations/VcvVacancyHackerrank';
import VcvVacancyHrm from './integrations/VcvVacancyHrm';
import VcvVacancyAssessfirst from './integrations/VcvVacancyAssessfirst';
import VcvVacancyChatbot from '@/routes_new/inner/vacancy/chatbot/VcvVacancyChatbot';
import video from '@/routes_new/inner/vacancy/video';
import competencies from '@/routes_new/inner/vacancy/competencies';
import accesses from '@/routes_new/inner/vacancy/accesses';
import invitation from './invitation';
import VacancySms from '@/routes_new/inner/vacancy/sms/VacancySms';
import special from '@/routes_new/inner/vacancy/special';
import application from '@/routes_new/inner/vacancy/application';
import talentq from '@/routes_new/inner/vacancy/talentq';
import video_interview_routes from '@/routes_new/inner/vacancy/video/routes';

export default [
  {
    path: '',
    component: InnerVacancy,
    props: true,
    children: [
      {
        path: 'headhunter',
        component: VcvVacancyHeadhunter,
        name: 'vacancy_headhunter',
        meta: {
          title: 'pageTitles.routes.vacancies.settings'
        }
      },
      {
        path: 'hackerrank',
        component: VcvVacancyHackerrank,
        name: 'vacancy_hackerrank',
        meta: {
          title: 'pageTitles.routes.vacancies.settings'
        }
      },
      {
        path: 'hrm',
        component: VcvVacancyHrm,
        name: 'vacancy_hrm',
        meta: {
          title: 'pageTitles.routes.vacancies.settings'
        }
      },
      {
        path: 'assessfirst',
        component: VcvVacancyAssessfirst,
        name: 'vacancy_assessfirst',
        meta: {
          title: 'pageTitles.routes.vacancies.settings'
        }
      },
      {
        path: 'chatbot',
        component: VcvVacancyChatbot,
        name: 'vacancy-chatbot',
        meta: {
          title: 'chatbot.chatbot'
        }
      },
      {
        path: 'landing',
        component: landing,
        name: 'vacancy_landing',
        meta: {
          title: 'pageTitles.routes.vacancies.settings'
        },
        alias: ['preferences/settings', 'preferences']
      },
      {
        path: 'basic',
        component: basic,
        name: 'vacancy_basic',
        meta: {
          title: 'pageTitles.routes.vacancies.settings'
        },
        alias: ['preferences/settings', 'preferences']
      },
      {
        path: 'application',
        component: application,
        name: 'vacancy_application',
        meta: {
          title: 'pageTitles.routes.vacancies.application'
        },
        props: route => ({
          vacancyId: route.params.id
        })
      },
      {
        path: 'tests',
        component: tests,
        props: true,
        name: 'vacancy_tests',
        meta: {
          title: 'pageTitles.routes.vacancies.tests'
        }
      },
      {
        path: 'vacancy-test',
        component: VacancyTestSettings,
        props: true,
        name: 'vacancy-test',
        meta: { title: 'pageTitles.routes.vacancies.tests' }
      },
      {
        path: 'external-integration',
        component: VcvExternalIntegration,
        props: true,
        name: 'vacancy_integration',
        meta: {
          title: 'settings.integrations.title'
        }
      },
      {
        path: 'video',
        name: 'vacancy_video',
        component: video,
        alias: 'video-interview',
        children: video_interview_routes,
        redirect: { name: 'vacancy_video_base' }
      },
      {
        path: 'competencies',
        name: 'vacancy_competencies',
        props: route => ({
          vacancyId: route.params.id
        }),
        component: competencies,
        meta: {
          title: 'pageTitles.routes.vacancies.competencies'
        }
      },
      {
        path: 'accesses',
        name: 'vacancy_accesses',
        props: route => ({
          vacancyId: route.params.id
        }),
        component: accesses,
        meta: {
          title: 'pageTitles.routes.vacancies.accesses'
        },
        alias: 'preferences/accesses'
      },
      {
        path: 'invitation',
        name: 'vacancy_invitation',
        props: route => ({
          vacancyId: route.params.id
        }),
        component: invitation,
        meta: {
          title: 'pageTitles.routes.vacancies.invitations'
        },
        alias: 'preferences/invitation'
      },
      {
        path: 'sms',
        name: 'vacancy_sms',
        props: route => ({
          vacancyId: route.params.id
        }),
        component: VacancySms,
        meta: {
          title: 'pageTitles.routes.vacancies.sms'
        },
        alias: 'preferences/sms'
      },
      {
        path: 'special',
        name: 'vacancy_special',
        props: route => ({
          vacancyId: route.params.id
        }),
        component: special,
        meta: {
          title: 'pageTitles.routes.vacancies.special'
        }
      },
      {
        path: 'talentq',
        name: 'vacancy_talentq',
        props: route => ({
          vacancyId: route.params.id
        }),
        component: talentq,
        meta: {
          title: 'pageTitles.routes.vacancies.talentq'
        }
      },
      {
        path: '*',
        redirect: { name: 'vacancy_basic' }
      },
      {
        path: '',
        redirect: { name: 'vacancy_basic' }
      }
    ]
  }
];
